




















































































































import {Vue, Component} from 'vue-property-decorator';
import InspectionFirstStep from '@/views/Inspection/InspectionFirstStep.vue';
import InspectionSecondStep from '@/views/Inspection/InspectionSecondStep.vue';
import InspectionThirdStep from '@/views/Inspection/InspectionThirdStep.vue';
import InspectionFourthStep from '@/views/Inspection/InspectionFourthStep.vue';
import {mapActions, mapGetters} from 'vuex';
import {extractDetailsFromBase64} from '@/services/api/image';
import moment from 'moment';
import {API} from '@/services/api/api';
import router from '@/router';
import {getImage, Utils} from '@/utils/Utils';

@Component({
  components: {
    InspectionFirstStep,
    InspectionSecondStep,
    InspectionThirdStep,
    InspectionFourthStep,
  },
  methods: {
    ...mapActions(['setInspectionData', 'showSuccessToast', 'showErrorToast']),
  },
  computed: {
    ...mapGetters(['getInspectionData']),
  },
})
export default class ReInspection extends Vue {
  stepNumber: number = 2;
  inspectionId = this.$route.params.id;
  isScreenLoading = true;
  getInspectionData: any;
  showSuccessToast: any;
  showErrorToast: any;
  btnLoader = false;
  setInspectionData: any;
  parentInspectionId: string | null = null;
  inspectionNumber: number = null;
  inspectionCode = '';

  inspectionData: any;
  zoneMasterId: number = null;

  imageData = [];

  stepsHeader = [
    {
      stepCount: 1,
      displayName: 'Select Inspection Point',
    },
    {stepCount: 2, displayName: 'Inspection Details'},
    {stepCount: 3, displayName: 'Select Recipient'},
    {stepCount: 4, displayName: 'Summary'},
  ];

  mounted() {
    this.getInspectionDataById();
  }

  async getInspectionDataById() {
    try {
      const response = await API.fetchInspectionDataById(this.inspectionId);

      if (response.data) {
        const data = response.data;

        //

        this.inspectionData = data;
        this.parentInspectionId = data.parentInspectionId;
        this.inspectionNumber = data.inspectionNumber;
        await this.mappDataToFields();
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.isScreenLoading = false;
      this.showErrorToast({msg: 'Network Error'});
    }
  }

  async mappDataToFields() {
    //

    const inspectionPoint = this.inspectionData.inspectionPoint;
    const inspectionDetail = this.inspectionData.inspectionDetail;
    const attachment = this.inspectionData.inspectionAttachment;
    const mailData = this.inspectionData.inspectionRecipient;
    const deck = this.inspectionData.deck;
    this.zoneMasterId = inspectionPoint.zoneMasterId;

    const modifyAttachment = attachment.map((me) => {
      return {...me, filePath: me.filePath + me.fileName};
    });
    const img = await getImage(deck.imagePath);
    this.setInspectionData({
      key: 'firstStep',
      payload: {
        frameSide: inspectionPoint.frameSide,
        shipId: inspectionPoint.shipId,
        isMisc: inspectionPoint.isMisc || true,
        deckId: inspectionPoint.deckId,
        structure: inspectionPoint.structure,
        zoneId: inspectionPoint.zoneMasterId,
        inspectionCode: inspectionDetail.inspectionID,
        deckImage: img,
        location_X: inspectionPoint.location_X,
        location_Y: inspectionPoint.location_Y,
        zoneName: inspectionPoint.zoneName,
        frameStart: inspectionPoint.frameStart,
        frameEnd: inspectionPoint.frameEnd,
        frameNumber: inspectionDetail.frameNumber,
      },
    }),
      this.setInspectionData({
        key: 'secondStep',
        payload: {
          inspectionDate: moment(inspectionDetail.inspectionDate).format('YYYY-MM-DD'),
          voyageConditionId: inspectionDetail.voyageConditionId,
          voyage: inspectionDetail.voyageData,
          findingId: inspectionDetail.findingsId,
          frame: inspectionDetail.frameNumber,
          length: inspectionDetail.dimentionLength,
          lengthUnit: inspectionDetail.lengthUnit,
          width: inspectionDetail.dimentionWidth,
          widthUnit: inspectionDetail.widthUnit,
          workOrder: inspectionDetail.workOrder,
          severityId: inspectionDetail.severityId,
          summary: inspectionDetail.summary,
          reInspectionDate: moment(inspectionDetail.reInspectionDate).format('YYYY-MM-DD'),
          isActionPlanReq: inspectionDetail.isActionPlanRequired,

          attachment: modifyAttachment,
        },
      }),
      this.setInspectionData({
        key: 'thirdStep',
        payload: mailData,
      });

    this.isScreenLoading = false;
  }

  closeLoader() {
    this.isScreenLoading = false;
  }

  increaseStep() {
    var validator;
    switch (this.stepNumber) {
      case 1:
        validator = this.$refs.firstStep;
        return validator.firstStepValidator();
      case 2:
        validator = this.$refs.secondStep;
        return validator.saveSecondStepData();
      case 3:
        validator = this.$refs.thirdStep;
        return validator.saveThirdStepData();
      default:
        break;
    }
  }

  decreaseStep() {
    this.stepNumber--;
  }

  switchScreen() {
    this.stepNumber++;
  }

  async getInspectionCode() {
    try {
      const response = await API.fetchReInspectionId(this.parentInspectionId);
      if (response.data) {
        const data = response.data;

        return data.inspectioncode;
      } else {
        this.showErrorToast({msg: response.error});
        return response.error;
      }
    } catch (error) {
      this.showErrorToast({msg: error});
      return error;
    }
  }

  async onCreateClick() {
    this.btnLoader = true;

    const firstStep = this.getInspectionData.firstStep;
    const secondStep = this.getInspectionData.secondStep;
    const attachment = this.getInspectionData.secondStep.attachment;

    const inspectionCode = await this.getInspectionCode();
    if (inspectionCode === undefined) {
      this.showErrorToast({msg: 'Something went wrong'});
      return;
    } else this.inspectionCode = inspectionCode;

    var imageData = $.extend(true, [], attachment);

    const modifyAttachment = await Promise.all(
      imageData.map(async (me) => {
        const filePath = me.filePath;

        const blobResponse = await API.convertImgURLToBLob(filePath);
        const base64Url = await Utils.ngxBase64(blobResponse);
        const sendAbleUrl = extractDetailsFromBase64(base64Url).url;
        const fileType = extractDetailsFromBase64(base64Url).imageType;

        return {
          ...me,
          attachmentId: null,
          filePath: sendAbleUrl,
          fileType: fileType,
        };
      })
    );

    // imageData.forEach((data) => {
    //   if (!data.filePath.includes('base64')) {
    //     data.filePath = data.filePath.slice(
    //       0,
    //       data.filePath.lastIndexOf('/') + 1
    //     );
    //   } else
    //     data.filePath = data.filePath = extractDetailsFromBase64(
    //       data.filePath
    //     ).url;
    // });

    //

    const thirdStep = this.getInspectionData.thirdStep;

    const params = {
      // inspectionId: this.inspectionId,
      parentInspectionId: this.parentInspectionId,
      inspectionNumber: this.inspectionNumber,
      inspectionPoint: {
        shipId: firstStep.shipId,
        deckId: firstStep.deckId,
        isMisc: firstStep.miscStructureStatus,
        zoneMasterId: firstStep.zoneId,
        structure: firstStep.structure,
        location_X: firstStep.location_X,
        location_Y: firstStep.location_Y,

        frameSide: firstStep.frameSide,
      },
      inspectionDetail: {
        inspectionDate: moment(secondStep.inspectionDate).format('YYYY-MM-DDThh:mm:ss'),
        inspectionID: this.inspectionCode,
        voyageData: secondStep.voyage,

        voyageConditionId: secondStep.voyageConditionId,
        findingsId: secondStep.findingId,
        frameNumber: secondStep.frame,
        dimentionLength: secondStep.length,
        lengthUnit: secondStep.lengthUnit,
        dimentionWidth: secondStep.width,
        widthUnit: secondStep.widthUnit,
        zoneMasterId: firstStep.zoneId,
        workOrder: secondStep.workOrder,
        severityId: secondStep.severityId,
        summary: secondStep.comment,
        reInspectionDate: moment(secondStep.reInspectionDate).format('YYYY-MM-DDThh:mm:ss'),
        isActionPlanRequired: secondStep.isActionPlanReq,
        isActive: true,
      },
      inspectionRecipient: {
        mailToUserId: thirdStep.mailToUserId,
        mailCcUserId: thirdStep.mailCcUserId,
        mailCcEmailAddress: thirdStep.mailCcEmailAddress,
      },
      inspectionAttachment: modifyAttachment,
    };
    //
    try {
      const response = await API.createReInspection(params);
      //

      if (response.data) {
        // this.$router.push('/inspection-list');
        this.$router.go(-1);
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network Error'});
    } finally {
      this.btnLoader = false;
    }
  }

  onBackBtnClick() {
    this.$router.go(-1);
  }
}
